import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  IEventoGenerico,
  IFilter,
  IPopulate,
  IQueryParam,
  TipoEventoGenerico,
} from 'modelos/src';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { Subscription } from 'rxjs';
import { IColumnas } from '../../../../../auxiliares/tabla/tabla.component';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { IFiltroTabla } from '../../../../../auxiliares/tabla/filtro/filtro.component';
import { EventosGenericosHelperService } from '../../helper';

@Component({
  selector: 'app-historico-evento-generico-dialog',
  templateUrl: './historico-evento-generico-dialog.component.html',
  styleUrl: './historico-evento-generico-dialog.component.scss',
  standalone: false,
})
export class HistoricoEventoGenericoDialogComponent
  implements OnInit, OnDestroy
{
  data = inject<{
    idDispositivo: string;
    tipo: string;
    tipoEvento: TipoEventoGenerico;
  }>(MAT_DIALOG_DATA);
  private lista2 = inject(Lista2Service);
  private eventosHelper = inject(EventosGenericosHelperService);
  helper = inject(HelperService);
  dialog = inject(MatDialog);
  dialogRef =
    inject<MatDialogRef<HistoricoEventoGenericoDialogComponent>>(MatDialogRef);

  public loading: boolean = true;
  public form?: FormGroup;

  public listando = false;
  //// Tabla nueva
  public name = 'HistoricoEventoGenericoDialogComponent';
  public eventosHistorico: IEventoGenerico[] = [];
  public eventosHistorico$?: Subscription;
  public totalCount = 0;
  public columnas?: IColumnas<IEventoGenerico>[];

  // Configuración de filtros
  public filtros: IFiltroTabla[] = [];

  public populate: IPopulate[] = [
    {
      path: 'alarma',
      populate: [
        {
          path: 'domicilio',
          select: 'direccion',
        },
        {
          path: 'modelo',
          select: 'marca modelo',
        },
        {
          path: 'comunicador',
          select: 'marca modelo',
        },
        {
          path: 'idServiciosContratados',
        },
      ],
    },
    {
      path: 'activo',
      select: 'identificacion',
    },
    {
      path: 'tracker',
      select: 'identificacion',
    },
    {
      path: 'luminaria',
      select: 'identificacion',
    },
    {
      path: 'gateway',
      select: 'nombre',
    },
    {
      path: 'botonBluetooth',
      select: 'mac',
    },
    {
      path: 'sirena',
      select: '_id',
    },
    {
      path: 'cliente',
      select: 'nombre',
    },
  ];

  public query: IQueryParam = {
    populate: JSON.stringify(this.populate),
    sort: '-fechaCreacion',
    page: 0,
    limit: 25,
    includeChildren: true,
    childrenLevel: 0,
    excludeTotalCount: true,
  };

  public async listar(): Promise<void> {
    this.listando = true;

    const filter: IFilter<IEventoGenerico> = {
      idEntidad: this.data?.idDispositivo || null,
      tipoEvento: this.data.tipoEvento,
      estado: { $ne: 'Sin Tratamiento' },
    };

    const query = { ...this.query };
    query['filter'] = JSON.stringify(filter);

    this.eventosHistorico$?.unsubscribe();
    this.eventosHistorico$ = this.lista2
      .eventosGenericos(query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.eventosHistorico = data.datos;
        this.listando = false;
      });
  }

  // Acciones
  public async detalles(evento: IEventoGenerico) {
    // TODO: Implementar navegación a detalles de evento genérico
  }

  // Tabla
  private setColumnas() {
    const columnas: IColumnas<IEventoGenerico>[] = [
      // Fecha
      {
        header: {
          label: 'Fecha',
        },
        row: {
          fecha: (dato) => dato.fechaCreacion,
          hace: true,
          noData: 'Sin fecha',
        },
      },
      // Categoría: badge del color de la categoría con el nombre adentro
      {
        header: {
          label: 'Categoría',
        },
        row: {
          html: (dato) => this.eventosHelper.categoriaHtml(dato),
          noData: 'Sin categoría',
        },
      },
      // Nombre evento
      {
        header: {
          label: 'Evento',
        },
        row: {
          parse(dato) {
            return dato.valores?.titulo;
          },
          noData: 'Sin título',
        },
      },
      // Detalles
      {
        header: {
          label: 'Detalles',
        },
        row: {
          parse(dato) {
            return (dato.valores as any)?.mensaje;
          },
          noData: 'Sin detalles',
        },
      },
      // Estado
      {
        header: {
          label: 'Estado',
        },
        row: {
          estado: (dato) =>
            EventosGenericosHelperService.estadoEvento(dato.estado),
          noData: 'Sin estado',
        },
      },
    ];
    this.columnas = columnas;
  }

  private inicializarFiltros() {
    this.filtros = [
      {
        label: 'Fecha',
        tipo: 'dateRange',
        filter: {
          field: 'fechaCreacion',
        },
      },
      {
        label: 'Estado',
        tipo: 'select',
        filter: {
          field: 'estado',
        },
        elementos: [
          'Sin Tratamiento',
          'Pendiente',
          'En Atención',
          'Liberada',
          'Finalizada',
          'En Espera',
        ],
        multiple: true,
      },
    ];
  }

  // Hooks
  async ngOnInit() {
    this.setColumnas();
    this.inicializarFiltros();
    await this.listar();
    this.loading = false;
  }

  async ngOnDestroy() {
    this.eventosHistorico$?.unsubscribe();
  }
}
